import React, { lazy } from 'react';
import { BookOpenIcon, GiftIcon, CheckCircle2Icon } from 'lucide-react';
export function OfferSection() {
  return <section className="w-full bg-cream py-20 px-4" data-id="element-64">
      <div className="max-w-5xl mx-auto" data-id="element-65">
        <div className="text-center mb-16" data-id="element-66">
          <h2 className="text-3xl md:text-5xl font-bold text-brown-primary mb-4 font-serif" data-id="element-67">
            He condensado años de "ensayo y error" en un sistema digital de
            lectura rápida (y audio) que puedes empezar esta misma noche.
          </h2>
          <p className="text-xl text-brown-secondary mt-6" data-id="element-68">
            Lo que vas a lograr por solo $9 USD:
          </p>
        </div>

        {/* Main Product */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-rose-gold/20 mb-12" data-id="element-69">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-8 md:p-12 items-center" data-id="element-70">
            <div data-id="element-71">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brown-primary/10 mb-4" data-id="element-72">
                <BookOpenIcon className="w-4 h-4 text-brown-primary" data-id="element-73" />
                <span className="text-xs font-bold tracking-widest text-brown-primary uppercase" data-id="element-74">
                  MÉTODO PIEL DE VIDRIO
                </span>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-brown-primary mb-4 font-serif" data-id="element-75">
                El sistema completo
              </h3>
              <ul className="space-y-4 mb-6" data-id="element-76">
                <li className="flex items-start gap-3" data-id="element-77">
                  <CheckCircle2Icon className="w-5 h-5 text-rose-gold shrink-0 mt-0.5" data-id="element-78" />
                  <span className="text-brown-secondary" data-id="element-79">
                    <strong className="text-brown-primary" data-id="element-80">
                      La Lista de Selección:
                    </strong>{' '}
                    Los nombres exactos de los productos de Farmacias Similares,
                    del Ahorro o Benavides que sí funcionan.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-81">
                  <CheckCircle2Icon className="w-5 h-5 text-rose-gold shrink-0 mt-0.5" data-id="element-82" />
                  <span className="text-brown-secondary" data-id="element-83">
                    <strong className="text-brown-primary" data-id="element-84">
                      El Ciclo de 4 Noches:
                    </strong>{' '}
                    La estrategia maestra para exfoliar, renovar y recuperar tu
                    barrera cutánea sin rojeces.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-85">
                  <CheckCircle2Icon className="w-5 h-5 text-rose-gold shrink-0 mt-0.5" data-id="element-86" />
                  <span className="text-brown-secondary" data-id="element-87">
                    <strong className="text-brown-primary" data-id="element-88">
                      Protocolo de Poros:
                    </strong>{' '}
                    Cómo limpiar profundamente para que tu piel brille de forma
                    natural, no por grasa.
                  </span>
                </li>
              </ul>
              <div className="text-sm font-bold text-brown-primary/60 uppercase tracking-wider" data-id="element-89">
                Valor real: $27.00 USD
              </div>
            </div>
            <div className="relative aspect-[4/5] rounded-lg overflow-hidden shadow-lg" data-id="element-90">
              <img src="https://cdn.magicpatterns.com/uploads/6TJWfrmLZBk8Ea1Dpqx5Kp/mokup-1.png" alt="Método Piel de Vidrio" width={500} height={625} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-91" />
            </div>
          </div>
        </div>

        <div className="text-center mb-12" data-id="element-92">
          <h3 className="text-2xl md:text-3xl font-bold text-brown-primary mb-4 font-serif italic" data-id="element-93">
            TRIPLE REGALO: TU SISTEMA ANTI-ERRORES (GRATIS)
          </h3>
          <p className="text-lg text-brown-secondary" data-id="element-94">
            Al inscribirte hoy por $9 USD, te llevas estos 3 complementos de
            alto valor sin costo adicional:
          </p>
        </div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-95">
          {/* Bonus 1 */}
          <div className="bg-white rounded-xl shadow-md border border-cream-dark p-6 flex flex-col h-full" data-id="element-96">
            <div className="inline-flex items-center gap-2 mb-4" data-id="element-97">
              <GiftIcon className="w-5 h-5 text-rose-gold" data-id="element-98" />
              <span className="text-sm font-bold tracking-widest text-rose-gold uppercase" data-id="element-99">
                BONO #1
              </span>
            </div>
            <div className="aspect-square rounded-lg overflow-hidden mb-6 bg-cream-dark" data-id="element-100">
              <img src="https://cdn.magicpatterns.com/uploads/66YqHjwVfmKbcy8V6Q8j9d/PDv-B1.png" alt="La Visita Perfecta a la Farmacia" width={400} height={400} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-101" />
            </div>
            <h4 className="text-xl font-bold text-brown-primary mb-2 font-serif" data-id="element-102">
              La Visita Perfecta a la Farmacia (Checklist)
            </h4>
            <p className="text-brown-secondary text-sm mb-4 font-medium" data-id="element-103">
              Entra y sal con lo correcto en 10 minutos. Deja de comprar por
              impulso y empieza a comprar por función.
            </p>
            <div className="mt-auto flex items-center justify-between border-t border-cream-dark pt-4" data-id="element-104">
              <span className="text-sm text-brown-primary/60 line-through" data-id="element-105">
                Valor: $9.00 USD
              </span>
              <span className="font-bold text-rose-gold" data-id="element-106">Hoy: GRATIS</span>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white rounded-xl shadow-md border border-cream-dark p-6 flex flex-col h-full" data-id="element-107">
            <div className="inline-flex items-center gap-2 mb-4" data-id="element-108">
              <GiftIcon className="w-5 h-5 text-rose-gold" data-id="element-109" />
              <span className="text-sm font-bold tracking-widest text-rose-gold uppercase" data-id="element-110">
                BONO #2
              </span>
            </div>
            <div className="aspect-square rounded-lg overflow-hidden mb-6 bg-cream-dark" data-id="element-111">
              <img src="https://cdn.magicpatterns.com/uploads/trGC4yAcHA1PXULT5LAE4W/PDV-B2.png" alt="Calendario Express Noche a Noche" width={400} height={400} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-112" />
            </div>
            <h4 className="text-xl font-bold text-brown-primary mb-2 font-serif" data-id="element-113">
              Calendario Express 14 Días (Imprimible + Móvil)
            </h4>
            <p className="text-brown-secondary text-sm mb-4 font-medium" data-id="element-114">
              Cero dudas. Cada noche sabes exactamente qué toca. Tu rutina en
              piloto automático.
            </p>
            <div className="mt-auto flex items-center justify-between border-t border-cream-dark pt-4" data-id="element-115">
              <span className="text-sm text-brown-primary/60 line-through" data-id="element-116">
                Valor: $9.00 USD
              </span>
              <span className="font-bold text-rose-gold" data-id="element-117">Hoy: GRATIS</span>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white rounded-xl shadow-md border border-cream-dark p-6 flex flex-col h-full" data-id="element-118">
            <div className="inline-flex items-center gap-2 mb-4" data-id="element-119">
              <GiftIcon className="w-5 h-5 text-rose-gold" data-id="element-120" />
              <span className="text-sm font-bold tracking-widest text-rose-gold uppercase" data-id="element-121">
                BONO #3
              </span>
            </div>
            <div className="aspect-square rounded-lg overflow-hidden mb-6 bg-cream-dark" data-id="element-122">
              <img src="https://cdn.magicpatterns.com/uploads/pW1u7d6qDwBiJxaozL5Dgk/PDV-B3.png" alt="Guía SOS Qué Hacer Si Te Irritas" width={400} height={400} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-123" />
            </div>
            <h4 className="text-xl font-bold text-brown-primary mb-2 font-serif" data-id="element-124">
              Guía SOS Anti-Irritación (Protocolo 48h)
            </h4>
            <p className="text-brown-secondary text-sm mb-4 font-medium" data-id="element-125">
              ¿Te pasaste de fuerza? No abandones. Aquí te digo cómo calmar tu
              piel y retomar el camino en 2 días.
            </p>
            <div className="mt-auto flex items-center justify-between border-t border-cream-dark pt-4" data-id="element-126">
              <span className="text-sm text-brown-primary/60 line-through" data-id="element-127">
                Valor: $9.00 USD
              </span>
              <span className="font-bold text-rose-gold" data-id="element-128">Hoy: GRATIS</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}